// extracted by mini-css-extract-plugin
module.exports = {"loginHeader":"nnGV6","loginHeader-image":"T0QXA","loginHeader-description":"c2N2p","loginHeader-description-text":"kApgu"};